import { asStore } from '@src/application/store/as-store.ts';
import { ref } from 'vue';

export function useAuthComposable() {
    const authToken = asStore('authToken', () => ref<string|null>(null), true);

    function isLoggedIn() {
        return authToken.value !== null;
    }

    return {
        authToken,
        isLoggedIn,
    };
}
